//////////////////////// 注册MMS相关函数库 ////////////////////////
import {o_MMS_Admin_Login_Methods} from "../methods/MMS/Admin/Login";
import {o_MMS_Admin_Index_Methods} from "../methods/MMS/Admin/Index";

function oMethodsEngine(engine) {
  this.engine = engine;
  // 方法库初始化（初始化配置数据、Cookie数据）
  this.init();

  // 注册MMS系统组件
  this.MMS = {
    Admin: {
      Login: new o_MMS_Admin_Login_Methods(engine),
      Index: new o_MMS_Admin_Index_Methods(engine)
    },
    Management: {}
  }
  // 注册QMS系统组件
  this.QMS = {}
}

oMethodsEngine.prototype = {
  // 获取前端八爪鱼框架配置，此处因为是初始化所以不能使用tips、template引擎。
  init: function () {


  }
}

export {
  oMethodsEngine
}





// WEBPACK FOOTER //
// ./src/assets/octopus/engine/methods.js